module.exports = __webpack_public_path__ + "img/profil_lapper_Preben.4a07bf4a.png";